import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IFilterDropdownsForm } from '@core/models/dropdowns.model';
import { CodeManagementItem } from '../../../models/code-management.model';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { FilterDropdownsComponent } from '@shared/components/filter-dropdowns/filter-dropdowns.component';
import { CodeFiltersComponent } from '@shared/components/code-filters/code-filters/code-filters.component';
import { CodeListComponent } from '../code-list/code-list.component';
import { CodeFilters } from '@shared/components/models/code-filters.model';
import { AddCodeComponent } from '../add-code/add-code.component';
import { SecurityModule } from '@mynexus/mynexus-ui-lib';

@Component({
  selector: 'app-code-management',
  templateUrl: './code-management.component.html',
  styleUrls: ['./code-management.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    FilterDropdownsComponent,
    CodeFiltersComponent,
    CodeListComponent,
    AddCodeComponent,
    SecurityModule
  ]
})
export class CodeManagementComponent {
  @ViewChild('filterPanel') codeFiltersComponent!: CodeFiltersComponent;
  @ViewChild('filterChips') filterChipsComponent!: CodeFiltersComponent;
  @ViewChild(AddCodeComponent) addCodeComponent!: AddCodeComponent;
  
  title = 'Code Management';
  selectedFilters: IFilterDropdownsForm | null = null;
  codeFilters: CodeFilters = {};
  filterRefreshTrigger = 0;
  showAddCode = false;
  editingCode: CodeManagementItem | null = null;
  private previousPlanId: string | null = null;

  constructor(private messageService: MessageService) {}

  onFiltersSelected(filters: IFilterDropdownsForm): void {
    const currentPlanId = filters?.overrideTypeId || null;
    
    if (this.previousPlanId !== null && this.previousPlanId !== currentPlanId) {
      this.resetFilters();
    }
    
    this.previousPlanId = currentPlanId;
    this.selectedFilters = filters;
  }

  private resetFilters(): void {
    this.codeFilters = {};
    
    if (this.codeFiltersComponent) {
      this.codeFiltersComponent.clearAllFilters();
    }
    if (this.filterChipsComponent) {
      this.filterChipsComponent.clearAllFilters();
    }
    
    this.filterRefreshTrigger++;
  }

  onCodeFiltersApplied(filters: CodeFilters): void {
    this.codeFilters = filters;
    this.filterRefreshTrigger++;
  }

  toggleFilters(): void {
    if (this.codeFiltersComponent) {
      this.codeFiltersComponent.toggleFilterVisibility();
    }
  }

  get filterButtonLabel(): string {
    if (this.filterChipsComponent && this.filterChipsComponent.hasActiveFilters) {
      return `${this.filterChipsComponent.appliedFilters.length} filters applied`;
    }
    return 'Filter';
  }

  get isPlanSelected(): boolean {
    return !!(this.selectedFilters?.overrideTypeId);
  }

  get isFilterPanelOpen(): boolean {
    return this.codeFiltersComponent?.isFilterVisible || false;
  }

  get hasActiveFilters(): boolean {
    return this.filterChipsComponent?.hasActiveFilters || false;
  }

  get isAddCodeDisabled(): boolean {
    return this.isFilterPanelOpen 
  }

  addNewCode(): void {
    this.editingCode = null;
    this.showAddCode = true;
    
    setTimeout(() => {
      if (this.addCodeComponent?.codeInfoComponent) {
        this.addCodeComponent.codeInfoComponent.focusSearchInput();
      }
    });
  }

  onEditCode(code: CodeManagementItem): void {
    this.editingCode = code;
    this.showAddCode = true;
  }

  onDeleteCode(code: CodeManagementItem): void {
    this.messageService.add({
      severity: 'warn',
      summary: 'Delete Code',
      detail: `Are you sure you want to delete code ${code.code}?`,
      life: 5000
    });
  }

  onCancelAddCode(): void {
    this.showAddCode = false;
    this.editingCode = null;
  }

  onSaveCode(formData: any): void {
    this.showAddCode = false;
    this.editingCode = null;
    
    setTimeout(() => { this.addNewCode(); });
  }
}
